import React from 'react';
import ConfirmationButton from './ConfirmationButton';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelButton from './CancelButton';

export default function ConfirmationSection({ text, onCancel, onConfirm, setTableRef }) {
  return (
    <section className="section-style" ref={setTableRef}>
      <span className="confirmation-text">{text}</span>
      <div className="confirmation-button-group">
        <CancelButton label="Cancel" icon={<CancelOutlinedIcon />} onClick={onCancel} />
        <ConfirmationButton label="Confirm" icon={<CheckCircleOutlinedIcon />} onClick={onConfirm} />
      </div>
    </section>
  );
}
